import * as actionTypes from '../types/finishedProduct';

export function getFinishedProduct(payload) {
  return {
    type: actionTypes.GET_FINISHED_PRODUCT,
    payload
  };
}
export function getFinishedProductSuccess(payload) {
  return {
    type: actionTypes.GET_FINISHED_PRODUCT_SUCCESS,
    payload
  };
}
export function getFinishedProductFail(payload) {
  return {
    type: actionTypes.GET_FINISHED_PRODUCT_FAIL,
    payload
  };
}

export function confirmFinishedProduct(payload) {
  return {
    type: actionTypes.CONFIRM_FINISHED_PRODUCT,
    payload
  };
}
export function confirmFinishedProductSuccess(payload) {
  return {
    type: actionTypes.CONFIRM_FINISHED_PRODUCT_SUCCESS,
    payload
  };
}
export function confirmFinishedProductFail(payload) {
  return {
    type: actionTypes.CONFIRM_FINISHED_PRODUCT_FAIL,
    payload
  };
}

export function stornoFinishedProduct(payload) {
  return {
    type: actionTypes.STORNO_FINISHED_PRODUCT,
    payload
  };
}
export function stornoFinishedProductSuccess(payload) {
  return {
    type: actionTypes.STORNO_FINISHED_PRODUCT_SUCCESS,
    payload
  };
}
export function stornoFinishedProductFail(payload) {
  return {
    type: actionTypes.STORNO_FINISHED_PRODUCT_FAIL,
    payload
  };
}

export function setCancelSendToSap(payload) {
  return {
    type: actionTypes.SET_CANCEL_SEND_TO_SAP,
    payload
  };
}

export function setCancelSendToSapSuccess(payload) {
  return {
    type: actionTypes.SET_CANCEL_SEND_TO_SAP_SUCCESS,
    payload
  };
}

export function setCancelSendToSapFail(payload) {
  return {
    type: actionTypes.SET_CANCEL_SEND_TO_SAP_FAIL,
    payload
  };
}
